<template>
  <CatalogCrudView
    title="Métodos de pagamento"
    subtitle="Padronize os meios utilizados em cobranças e pagamentos."
    singular="método de pagamento"
    list-title="Métodos cadastrados"
    icon="card"
    :service="service"
    :fields="fields"
    :columns="columns"
    :form-defaults="formDefaults"
  />
</template>

<script>
import CatalogCrudView from '../components/CatalogCrudView.vue'
import service from '../services/paymentMethodService'

export default {
  name: 'PaymentMethodsView',
  components: { CatalogCrudView },
  data: () => ({
    service,
    formDefaults: { name: '', code: '', isActive: true },
    fields: [
      { key: 'name', label: 'Nome', required: true, maxlength: 100, placeholder: 'Ex.: Pix', span: 7 },
      { key: 'code', label: 'Código', required: true, maxlength: 30, placeholder: 'Ex.: PIX', uppercase: true, span: 3 },
      { key: 'isActive', label: 'Situação', type: 'select', span: 2, options: [{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }] }
    ],
    columns: [
      { text: 'Id', value: 'id' }, { text: 'Nome', value: 'name', emphasis: true },
      { text: 'Código', value: 'code', type: 'code' }, { text: 'Situação', value: 'isActive', type: 'status' },
      { text: 'Criado em', value: 'createdAt', type: 'date' }
    ]
  })
}
</script>
